<template>
    <div class="sw-modal edit-task">
        <div v-click-outside="cancel" class="sw-modal-content" v-on:click.stop>
            <div class="row sw-modal-heading">
                <div class="col text-center">
                    <h4>
                        <i class="fas fa-list" aria-hidden="true"></i>
                        Add a Task
                    </h4>
                </div>
            </div>
            <div class="sw-modal-body" v-if="task">
                <ValidationObserver ref="taskForm">
                    <form v-on:submit.prevent="saveTask()" >
                        <ul>
                            <li class="row question">
                                <label for="task-name" class="col-12 question__question">Name</label>
                                <div class="col-12">
                                    <ValidationProvider rules="required|min:3" v-slot="{ errors }">
                                        <input type="text" v-model="task.name" id="task-name" placeholder="Task name" class="short-question">
                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </li>

                            <li class="row question section-end">
                                <label for="task-date" class="col-12 question__question">Due date</label>
                                <div class="col-12">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <input type="text" v-model="scheduledDateForDisplay" id="task-date" placeholder="Enter a date" class="short-question" v-on:click="showCalendar" readonly autocomplete="off">
                                        <edit-date v-if="showingCalendar"
                                                   title="Select a date and time"
                                                   v-bind:date="task.scheduledDate"
                                                   v-bind:minDate="'today'"
                                                   v-bind:ownerReference="task.reference"
                                                   v-bind:error="error"
                                                   v-bind:success="success"
                                                   v-click-outside.stop="hideCalendar">
                                        </edit-date>
                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </li>
                        </ul>

                        <div v-show="waiting">
                            <Spinner/>
                        </div>  

                        <div v-show="!waiting" class="col-12">
                            <div v-if="error">
                                <div class="col-12 alert alert-danger" role="alert">
                                    {{error}}
                                </div>
                                <button v-on:click.prevent="cancel" class="btn btn-secondary">Close</button>
                            </div>
                            <div v-else-if="success">
                                <div class="col-12 alert alert-success" role="alert">
                                    {{success}}
                                </div>
                                <button v-on:click.prevent="$root.$emit('finished-editing-task')" class="btn btn-secondary">Done</button>
                            </div>
                            <div v-else class="row">
                                <div class="col-6">
                                    <button v-on:click.prevent="cancel" class="btn btn-secondary">Cancel</button>
                                </div>
                                <div class="col-6">
                                    <button class="btn btn-primary">
                                        <template>Add</template>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
    import * as dayjs from 'dayjs'

    import Spinner from '../Spinner.vue'
    import EditDate from '../EditDate.vue'

    import { store, getters } from '../../store.js'
    import { ValidationObserver, ValidationProvider } from 'vee-validate'

    import { datesMixin } from "../../mixins/DatesMixin"

    export default {
        name: 'EditTask',
        components: { Spinner, ValidationObserver, ValidationProvider, EditDate },
        mixins: [datesMixin],
        props: {
            task: Object
        },
        data: function() {
          return {
              copy: {},
              scheduledDateForDisplay: null,
              showingCalendar: false,
              waiting: false,
              error: null,
              success: null
          }
        },
        computed: {
            getEstablishment: function() {
                return getters.getCurrentEstablishment();
            },
            getUnitTypeForDisplay: function() {
                return getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
            }
        },
        methods: {
            updateDueDate: function (ownerReference, date) {
                if (ownerReference === this.task.reference) {
                    console.log(date);
                    this.task.scheduledDate = date;
                    this.scheduledDateForDisplay = this.friendlyDateAndTime(date);
                    this.hideCalendar();
                }
            },
            cancel: function() {
                if (!this.showingCalendar) {
                    console.log("cancel");
                    if (typeof this.copy.reference !== 'undefined') {
                        // we need to reset the values to what they were before
                        this.task.name = this.copy.name;
                        this.task.scheduledDate = this.copy.scheduledDate;
                    }
                    this.$root.$emit('finished-editing-task');
                }
            },
            saveTask: function () {
                console.log(this.checkInOut)
                this.$refs.taskForm.validate().then(success => {
                    console.log("Validated:" + this.scheduledDate + " . Success: " + success);
                    if (!success) {
                        return
                    }

                    console.log("saving task");
                    this.waiting = true;
                    this.error = null;

                    const body = {
                        name: "" + this.task.name,
                        scheduledDate: this.task.scheduledDate
                    };

                    let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/tasks/todos';

                    if (typeof this.task.reference === 'undefined') {
                        this.$http.post(url, body
                        ).then(response => {
                            console.log("Task added. Response: " + response);
                            this.waiting = false;
                            this.success = "Task added";
                            this.$root.$emit('task-added', dayjs(this.task.scheduledDate).format("YYYY-MM-DD"));
                        }).catch(error => {
                            this.waiting = false
                            if (error.response) {
                                this.error = "Error: " + error.response.data.message
                            } else {
                                this.error = "Sorry, we can't seem to reach our servers! Please try again"
                            }
                        })
                    }

                })
            },
            showCalendar: function () {
                this.showingCalendar = true
            },
            hideCalendar: function() {
                this.showingCalendar = false
            }
        },
        mounted() {
            console.log("Mounting add task");

            if (this.task && typeof this.task.reference !== 'undefined') {
                this.copy.name = this.task.name;
                this.copy.scheduledDate = this.task.scheduledDate;
            }

            this.$root.$on('save-edit-date', this.updateDueDate);
            this.$root.$on('close-edit-date', this.hideCalendar);
        },
        beforeDestroy() {
            this.$root.$off('save-edit-date', this.updateDueDate);
            this.$root.$off('close-edit-date', this.hideCalendar);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/abstracts/variables";
    @import "../../styles/components/modal";
    @import "../../styles/layout/forms-account";
    @import "../../styles/layout/divisions";
    @import "../../styles/components/edit_task";
    @import "../../styles/components/question_answer";
</style>

<!--These are overrides for the flatpickr inputs -->
<style lang="scss">
    @import "../../styles/overrides/flatpickr";
</style>
